<script lang="ts">
	import classNames from 'classnames';
	import { fade } from 'svelte/transition';

	export let fullHeight = false;
	export let absolute = false;

	let cls: string | undefined = undefined;
	export { cls as class };

	export let iconClass = 'w-[70px] h-[70px]';
</script>

<div
	class={classNames(
		'bg-white',
		fullHeight ? 'h-full w-full flex-1' : cls ?? 'h-[80vh]',
		absolute && 'absolute left-0 top-0',
		'center z-1'
	)}
	transition:fade={{ duration: 200 }}
>
	<img class={iconClass} src="/icons/chess.gif" alt="chess" />
</div>
